// extracted by mini-css-extract-plugin
export default {"root":"TldlDurationSelector_root__0T+Mb"};